export default {
  mask: '00',
  length: 0,
  style: 0
};